<template>
    <div>
        <b-row class="d-flex justify-content-between mt-4 mb-3">
            <b-col cols="3">
            </b-col>
            <b-col cols="9" class="d-flex flex-row-reverse">
                <div class="d-flex">
                    <el-switch
                        v-model="show_eligible_only"
                        class="mx-2"
                        active-color="#0BC196">
                    </el-switch>
                Only show eligible unit
                </div>
            </b-col>
        </b-row>
        <div v-if="unit_by_level.length === 0">
            No Units Found.
        </div>
        <div v-else>
            <b-row align-v="end" align-h="between" class="mb-4">
                <b-col cols="6" md="auto">
                    {{ selected_project.project_type }}
                </b-col>
                <b-col cols="6" md="auto">
                    <b-button variant="outline-secondary" @click="modals.expand_units = true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M344 0h144c13.3 0 24 10.7 24 24v144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0M168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/></svg>
                        <span>Expand</span>
                    </b-button>
                </b-col>
            </b-row>
            <div v-if="unitCategory(selected_project.project_type) !== 'landed'">
                <b-row>
                    <div class="table-select-unit">
                        <b-table-simple responsive bordered>
                            <b-tbody>
                                <b-tr v-for="(level, levelIndex) in filteredUnitByLevel" :key="levelIndex">
                                    <b-td v-if="level.length > 0">
                                        <h4>Level {{ level[0].floor_sort }}</h4>
                                        <span class="text-primary text-xs cursor-pointer" @click="openLevelPlan(level[0])">View level plan</span>
                                    </b-td>
                                    <b-td v-for="(unit, unitIndex) in level" :key="unitIndex"
                                        :class="{'bg-secondary': !unit}"
                                        :style="getCellStyle(unit)"
                                    >
                                        <div v-if="unit">
                                            <a href="javascript:void(0)" @click="selectUnit(unit)">
                                                <div :style="{
                                                        'cursor': unit.available_status === 'Open' ? 'pointer' : 'not-allowed'
                                                    }"
                                                    class="text-center"
                                                >
                                                    <p class="text-xs text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                                    <p class="font-weight-600">RM {{ unit.unit_price | moneyFormatter }}</p>
                                                    <p>{{ unit.unit_no }}</p>
                                                    <p>{{ unit.unit_type.unit_type_name }}</p>
                                                    <div class="m-0 p-0 text-right">
                                                        <p class="h2 p-0 my-2"
                                                            v-if="parseFloat(current_eligibility.max_eligibility) >= parseFloat(unit.unit_price)"
                                                        >
                                                            <b-icon icon="check-circle-fill" variant="success" v-b-tooltip.hover="'Eligible'"></b-icon>
                                                        </p>
                                                        <p class="h2 p-0 my-2" v-else>
                                                            <b-icon icon="x-circle-fill" variant="danger" v-b-tooltip.hover="'Not Eligible'"></b-icon>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </b-td>
                                    <b-td v-for="index in maxColumns - level.length" :key="'empty-' + index"></b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-row>
            </div>
            <div v-else>
                <b-row>
                    <div class="table-select-unit">
                        <b-table-simple responsive bordered>
                            <tbody>
                                <b-tr v-for="(row, rowIndex) in groupedUnits" :key="rowIndex">
                                    <b-td v-for="(unit, unitIndex) in row" :key="unitIndex"
                                        :class="{'bg-secondary': !unit}"
                                        :style="getCellStyle(unit)"
                                    >
                                        <div v-if="unit">
                                            <a href="javascript:void(0)" @click="selectUnit(unit)">
                                                <div :style="{
                                                        'cursor': unit.available_status === 'Open' ? 'pointer' : 'not-allowed'
                                                    }"
                                                    class="text-center"
                                                >
                                                    <p class="text-xs text-capitalize" :class="unit.available_status !== 'Not available' ? 'text-white' : 'text-muted'">{{ unit.available_status }}</p>
                                                    <p class="font-weight-600">RM {{ unit.unit_price | moneyFormatter }}</p>
                                                    <p>Unit {{ unit.unit_no }}</p>
                                                    <p>{{ unit.unit_type.unit_type_name }}</p>
                                                    <div class="m-0 p-0 text-right">
                                                        <p class="h2 p-0 mb-0"
                                                            v-if="parseFloat(current_eligibility.max_eligibility) >= parseFloat(unit.unit_price)"
                                                        >
                                                            <b-icon icon="check-circle-fill" variant="success" v-b-tooltip.hover="'Eligible'"></b-icon>
                                                        </p>
                                                        <p class="h2 p-0 mb-0" v-else>
                                                            <b-icon icon="x-circle-fill" variant="danger" v-b-tooltip.hover="'Not Eligible'"></b-icon>
                                                        </p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </b-td>
                                </b-tr>
                            </tbody>
                        </b-table-simple>
                    </div>
                </b-row>
            </div>
        </div>
        <LevelPlanModal :level_plan.sync="modals.level_plan" :level_data="levelSelected" />
        <ExpandsUnitsModal 
            :expand_units.sync="modals.expand_units"
            :unit_by_level="unit_by_level"
            :selected_project="selected_project"
            :unit-category="unitCategory"
            :filtered-unit-by-level="filteredUnitByLevel"
            :grouped-units="groupedUnits"
            :open-level-plan="openLevelPlan"
            :get-cell-style="getCellStyle"
            :max-columns="maxColumns"
            :select-unit="selectUnit"
        />
    </div>
</template>
<script>
import { Image, Button, Tooltip, Switch } from 'element-ui'
import LevelPlanModal from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/Modals/LevelPlanModal.vue'
import ExpandsUnitsModal from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/Modals/ExpandsUnitsModal.vue'
import { mapActions, mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useProductStore } from '@/stores/productStore'
import {UNIT_COLOR} from '@/assets/js/colors.js'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'

export default {
    props: {
        selected_project: {
            type: Object
        },
        is_proposal:{
            type: Boolean,
            default: false
        }
    },
    components: {
        LevelPlanModal,
        ExpandsUnitsModal,
        [Image.name]: Image,
        [Button.name]: Button,
        [Tooltip.name]: Tooltip,
        [Switch.name]: Switch,
    },
    data() {
        return {
             modals: {
                level_plan: false,
                expand_units: false,
            },
            show_eligible_only: true,
            original_unit_listing_group_by_level: [],
            UNIT_COLOR:UNIT_COLOR,
            levelSelected: null,
        }
    },
    computed: {
        ...mapState(useCustomerStore, ['current_eligibility']),
        unit_by_level(){
            if(this.selected_project){
                try {
                    this.original_unit_listing_group_by_level = JSON.parse(JSON.stringify(this.selected_project.unit_listing_group_by_level))
                } catch (error) {
                    return []
                }
                
                if(this.show_eligible_only){
                    var has_available_units = false
                    for (let i = 0; i < this.original_unit_listing_group_by_level.length; i++) {
                        this.original_unit_listing_group_by_level[i] = this.original_unit_listing_group_by_level[i].filter(item => {
                            return parseFloat(this.current_eligibility.max_eligibility) >= parseFloat(item.unit_price)
                        })
                        if(this.original_unit_listing_group_by_level[i].length > 0){
                            has_available_units = true
                        }
                    }
                    if(has_available_units){
                        return this.original_unit_listing_group_by_level
                    }
                    return []
                }
                return this.original_unit_listing_group_by_level
            }
            return []
        },


        // FOR LANDED PROPERTY
        groupedUnits() {
            const units = this.unit_by_level[0] // Assuming all units are in the first array of unit_by_level
            const unitsPerRow = 10 // Adjust as needed
            const groupedUnits = []

            if(!this._gHlp.isEmpty(units)) {
                for (let i = 0; i < units.length; i += unitsPerRow) {
                    groupedUnits.push(units.slice(i, i + unitsPerRow))
                }
            }
            return groupedUnits
        },
        ...mapState(useProductStore, ['current_product_data']),

        maxColumns() {
            return Math.max(...this.original_unit_listing_group_by_level.map(arr => arr.length))
        },

        filteredUnitByLevel() {
            return this.unit_by_level.filter(level => level.length > 0);
        },

        unitCategory() {
            const UNIT_TYPE_CATEGORY = {
                'Condominium': 'non-landed',
                'Service Apartment/ Residence': 'non-landed',
                'Service suites': 'non-landed',
                'Penthouse': 'non-landed',
                'Duplex': 'non-landed',
                'Flat': 'non-landed',
                'Apartment': 'non-landed',
                '1-sty terrace/link house': 'landed',
                '2-sty terrace/link house': 'landed',
                '3-sty terrace/link house': 'landed',
                '4-sty terrace/link house': 'landed',
                'Bungalow': 'landed',
                'Zero-lot bungalow': 'landed',
                'Mansion': 'landed',
                'Cluster Home': 'landed',
                'Semi- D': 'landed',
                'Villa': 'landed',
                'Shoplot/officelot': 'non-landed',
                'Townhouse': 'landed' // Typically considered landed
            };

            return type => UNIT_TYPE_CATEGORY[type] || 'unknown';
        }
    },
    // watch: {
    //     original_unit_listing_group_by_level: {
    //         async handler(newVal) {
    //             console.log(newVal)
    //             console.log('max', Math.max(...this.original_unit_listing_group_by_level.map(arr => arr.length)))
    //         }
    //     }
    // },
    methods: {
        ...mapActions(useProductStore, ['createPropertyProduct']),
        openLevelPlan(level) {
            this.levelSelected = level
            this.modals.level_plan = true
        },
        async selectUnit(unit){
            this.modals.expand_units = false
            // check if its a proposal product selection
            if(this.is_proposal){
                let data = {
                    project: this.selected_project,
                    unit: unit
                }
                initialProposalEventBus.$emit('selected-proposal-unit', data)
                return
            }

            if( unit.available_status !== 'Open'){
                return
            }

            useProductStore().$patch((state) => {
                state.current_product_data = { 
                    ...state.current_product_data, 
                    project: this.selected_project,
                    unit: unit,
                }
            })

            solutionEventBus.$emit('show-unit-selections')
        },
        getCellStyle(unit) {
            return unit
            ? { background: this.UNIT_COLOR[unit.available_status] }
            : null;
        },
    }
}
</script>